import React from 'react';
import moment from 'moment';
import {
  ButtonContained,
  Grid,
  SvgFlash,
  Typography,
  ButtonOutlined,
} from '@ntuctech/devex-tangram';
import styled from 'styled-components';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';
import CancelModal from './CancelModal';
import { GTM_ENV_VAR as GEV } from '../../../lib/eventTrackerFunction';
import { AMP_EVENT_NAME } from '../../../lib/amplitude';

const Container = styled(Grid)`
  padding: 2rem;
  border: 1px solid #eaeaea;
  margin-bottom: 1.5rem;
  border-radius: 0.5rem;
  background-color: #fff;

  > div {
    padding: 0;
  }

  .no-spacing {
    padding: 0;
    margin: 0.5rem 0;
  }

  .no-spacing-btn {
    padding: 0;
    margin: 0;
  }

  width: auto;

  .img {
    margin-top: 1.25rem;
    border-radius: 0.5rem;
  }

  .full-width {
    width: 100% !important;
  }

  .flex {
    display: flex;
  }

  .margin-20-y {
    margin: 1.25rem 0;
  }

  .margin-24-y {
    margin: 1.5rem 0;
  }

  .mine-shaft-66 {
    color: #666666;
  }

  .margin-bottom-20 {
    margin-bottom: 1.25rem;
  }

  .margin-top-20 {
    margin-top: 1.25rem;
  }

  .float-right {
    float: right;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    display: none !important;
    padding: 1rem;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    display: flex;
    padding: 1.5rem;
  }

  ${SCREEN_SIZE.From.Desktop} {
    display: flex;
  }
`;

const StyledButton = styled(ButtonContained)`
  min-width: unset !important;
`;

const StyledButtonOutLined = styled(ButtonOutlined)`
  min-width: unset !important;
  margin-top: 1rem !important;
`;

const StyledHr = styled.hr`
  height: 0.063rem;
  width: 100%;
  background-color: #eaeaea;
  border: 0;
  margin-bottom: 1.25rem;
`;

export const errorBannerFalse = (setErrorBanner) => {
  setErrorBanner({
    show: false,
    message: 0,
  });
};

const BusinessPreview = ({
  voucherData,
  isEditMode,
  addToCartBusiness,
  isB2bEnabled,
  testProps = false,
  track,
  isCheck,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isOkay, setIsOkay] = React.useState(testProps);
  /* eslint-disable no-useless-escape */
  const emailFormat = (data) => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      data
    );
  };
  const hasEmail = emailFormat(voucherData?.businessEmail);
  const hasOtherEmail = emailFormat(voucherData?.otherBusinessEmail);
  const haveQty = voucherData?.bussinessData?.some(
    (voucher) => voucher.amount || (voucher.value && voucher.qty > 0)
  );
  const isOtherBusinessEmailIsValid =
    voucherData.otherBusinessEmail?.localeCompare(voucherData.businessEmail) === 0;
  const isEnabled = isCheck
    ? hasEmail && hasOtherEmail && haveQty && !isOtherBusinessEmailIsValid
    : hasEmail && haveQty;

  const cartPage = isB2bEnabled ? '/cart/' : '/';
  const homepage = '/';

  React.useEffect(() => {
    if (isOkay) {
      setIsModalOpen(false);
      window.location.href = isEditMode ? cartPage : homepage;
    }
  }, [isOkay]);

  return (
    <Container container>
      <CancelModal
        open={isModalOpen}
        track={track}
        onClose={() => setIsModalOpen(false)}
        setIsOkay={setIsOkay}
      />
      <Grid item xs={12}>
        <Typography variant="titleXs">Preview</Typography>
      </Grid>
      <Grid item xs={12}>
        <img className="img" src={voucherData?.metadata?.image} alt="card-design" />
      </Grid>
      <Grid item xs={12} className="margin-20-y">
        <Typography variant="bodyM">{voucherData?.metadata?.message}</Typography>
      </Grid>
      <StyledHr />
      <Grid item xs={12}>
        <Typography className="mine-shaft-66" variant="bodySBold">
          Valid until
        </Typography>
        <div className="margin-bottom-20">
          <Typography variant="bodyS">
            {`${moment(new Date(new Date().setFullYear(new Date().getFullYear() + 1)))
              .add(12, 'days')
              .format('Do MMM YYYY')} (1 year 2 weeks)`}
          </Typography>
        </div>
      </Grid>
      <StyledHr />
      <Grid item xs={4}>
        <Typography className="mine-shaft-66" variant="bodySBold">
          Amount
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography className="mine-shaft-66" variant="bodySBold">
          Quantity
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography className="mine-shaft-66 float-right" variant="bodySBold">
          Subtotal
        </Typography>
      </Grid>
      {voucherData.bussinessData?.length > 0 &&
        voucherData.bussinessData.map((item) =>
          item.qty > 0 && (item.value > 0 || item.amount > 0) ? (
            <>
              <Grid item xs={4}>
                <Typography variant="bodyS">
                  $
                  {(item.amount || item.value).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="bodyS">x {item.qty.toLocaleString()}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography className="float-right" variant="bodyS">
                  $
                  {((item.value || item.amount) * item.qty).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
              </Grid>
            </>
          ) : null
        )}
      {voucherData.bussinessData?.reduce((acc, key) => acc + key.qty, 0) === 0 ? (
        <>
          <Grid item xs={4}>
            <Typography variant="bodyS">$0</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="bodyS">x 0</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className="float-right" variant="bodyS">
              $0
            </Typography>
          </Grid>
        </>
      ) : null}

      <StyledHr className="margin-top-20" />
      <Grid item xs={6}>
        <Typography variant="bodyS">Total quantity</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className="float-right" variant="bodyS">
          {Number(
            voucherData.bussinessData
              ?.filter((item) => item.amount > 0 || item.value > 0)
              .reduce((acc, val) => Number(acc) + Number(val.qty), 0) || 0
          ).toLocaleString()}
        </Typography>
      </Grid>
      <Grid item xs={6} className="margin-24-y">
        <Typography variant="priceS">Total</Typography>
      </Grid>
      <Grid item xs={6} className="margin-24-y">
        <Typography className="float-right" variant="bodyS">
          ${' '}
          {Number(
            voucherData.bussinessData?.reduce((acc, key) => {
              const totalAmount = Number(key.qty * (key.amount || key.value));
              return Number(acc) + totalAmount;
            }, 0) || 0
          ).toLocaleString(undefined, { minimumFractionDigits: 2 })}
        </Typography>
      </Grid>
      <div className="full-width flex">
        <StyledButton
          onClick={(e) => {
            addToCartBusiness(e);
            if (isEditMode) {
              track({
                [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.EDIT_SAVED,
                [GEV.MEMBER_TYPE]: 'B2B',
                [GEV.AMPLITUDE_VERTICAL]: AMP_EVENT_NAME.VERTICAL,
                [GEV.AMPLITUDE_CTA_LOCATION]: 'egifting | edit order',
                [GEV.AMPLITUDE_GIFTING_GIFT_ID]: voucherData.id,
                [GEV.AMPLITUDE_CTA_SUB_LOCATION]: null,
                [GEV.AMPLITUDE_DENOMINATION]: voucherData.denominatons,
                [GEV.AMPLITUDE_GIFTING_SEND_VIA]: 'email',
                [GEV.AMPLITUDE_GIFTING_RECIPIENT]: 'Y',
                [GEV.AMPLITUDE_GIFTING_MESSAGE]: voucherData.metadata?.message ? 'Y' : 'N',
                [GEV.AMPLITUDE_GIFTING_DATE_OF_DELIVERY]: 'Y',
                [GEV.AMPLITUDE_GIFTING_CATEGORY]: voucherData.metadata?.catergory,
                [GEV.AMPLITUDE_GIFTING_CARD_DESIGN]: voucherData.metadata?.name,
                [GEV.AMPLITUDE_GIFTING_MULTIPLE_RECIPIENTS]:
                  voucherData.otherBusinessEmail?.localeCompare(voucherData.businessEmail) === 0
                    ? 'N'
                    : 'Y',
              });
            }
          }}
          className="full-width no-spacing-btn"
          size="m"
          disabled={!isEnabled}
          data-testid="add-to-cart-business"
        >
          {isEditMode ? 'Save' : 'Add to cart'}
        </StyledButton>
      </div>
      <div className="full-width flex">
        <StyledButtonOutLined
          className="full-width no-spacing-btn"
          size="m"
          data-testid="button-cancel"
          onClick={() => {
            track({
              [GEV.AMPLITUDE_EVENT_NAME]: isEditMode
                ? AMP_EVENT_NAME.EDIT_CANCEL
                : AMP_EVENT_NAME.CUSTOMISATION_CANCELLED,
              [GEV.MEMBER_TYPE]: 'B2B',
              [GEV.AMPLITUDE_VERTICAL]: AMP_EVENT_NAME.VERTICAL,
              [GEV.AMPLITUDE_CTA_LOCATION]: 'egifting | customize selection',
              [GEV.AMPLITUDE_CTA_SUB_LOCATION]: '',
              [GEV.AMPLITUDE_GIFTING_SEND_VIA]: 'email',
              [GEV.AMPLITUDE_GIFTING_DATE_OF_DELIVERY]: 'Y',
              [GEV.AMPLITUDE_GIFTING_MULTIPLE_RECIPIENTS]:
                voucherData.otherBusinessEmail?.localeCompare(voucherData.businessEmail) === 0
                  ? 'N'
                  : 'Y',
            });
            if ((voucherData.businessEmail || voucherData.otherBusinessEmail) && !isEditMode) {
              setIsModalOpen(true);
            } else {
              const directUrl = isEditMode ? cartPage : homepage;
              window.location.href = directUrl;
            }
          }}
        >
          Cancel
        </StyledButtonOutLined>
      </div>
      <Grid item xs={12} className="margin-top-20 flex">
        <SvgFlash color="#666666" />
        <Typography className="mine-shaft-66" variant="bodyS">
          Receive order instantly when you pay via debit or credit card.
        </Typography>
      </Grid>
    </Container>
  );
};

export default BusinessPreview;
